/* eslint-disable @typescript-eslint/camelcase */
import { Component, Vue, Watch } from 'vue-property-decorator'
import { FormStructure } from '@master/model/structure/FormStructure'
import { FormBaseMixin } from './FormBaseMixin'
import { BiRoleTypeOptions, BisoFields, BisoStatusOptions, BisoTypeOptions, BusinessInterestShareholding, DeclarantTypeOptions } from '@core/model/recruit/forms/BusinessInterestShareholding'

@Component
export class DeclarationBusinessInterestMixin extends FormBaseMixin {
  protected type = BusinessInterestShareholding

  get bisoInfoStructure (): FormStructure<BisoFields> {
    return [
      {
        label: 'Declaration Type',
        key: 'submissionType',
        buttonName: 'submissionType',
        type: 'radio',
        displayDirection: 'row',
        options: BisoTypeOptions
      },
      {
        label: 'Declarant',
        key: 'declarantType',
        buttonName: 'declarantType',
        type: 'radio',
        displayDirection: 'row',
        options: DeclarantTypeOptions
      }
    ]
  }

  get biInfoStructure (): FormStructure<BisoFields> {
    return [
      {
        label: 'Please tick (√) either choice and complete the following section',
        key: 'status',
        buttonName: 'status',
        type: 'radio',
        // displayDirection: 'row',
        options: BisoStatusOptions
      },
      {
        label: 'Name of Entity',
        key: 'biEntityName'
      },
      {
        label: 'Place of Incorporation/ Establishment (Country)',
        key: 'biEntityCountry'
      },
      {
        label: 'Nature of Business',
        key: 'biEntityNature'
      },
      {
        label: 'Role / Capacity',
        key: 'biRole',
        buttonName: 'roleCapacity',
        type: 'smart',
        // multiple: true,
        // displayDirection: 'row',
        options: BiRoleTypeOptions
      },
      {
        label: 'Specify Role',
        key: 'biRoleSpecified',
        show: (this.formData as BusinessInterestShareholding).data.biRole === 'others'
      },
      {
        label: 'Date of Acquiring / Effective Date of Changes to Existing Business Interest',
        key: 'biEffectiveDate',
        type: 'date'
      }
    ]
  }

  get soInfoStructure (): FormStructure<BisoFields> {
    return [
      {
        label: 'Name of Entity',
        key: 'ownEntityName'
      },
      {
        label: 'Place of Incorporation/ Establishment (Country)',
        key: 'ownEntityCountry'
      },
      {
        label: 'Nature of Business',
        key: 'ownEntityNature'
      },
      {
        label: 'Date of Acquisition / Changes',
        key: 'ownEffectiveDate',
        type: 'date'
      },
      {
        label: 'Percentage Shareholding/Ownership you hold in the entity (%)',
        key: 'ownPercentage',
        type: 'number'
      }
    ]
  }

  get agreeErrMsg () {
    return this.formDataErrors?.find(err => err.key === 'agree')?.msg
  }
}
